import { extUrl } from "./api";

export const localTodayISO = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};

export const scheduleStatus = (startDate, endDate) => {
  const today = localTodayISO();
  if (startDate && today < startDate) return "upcoming";
  if (endDate && today > endDate) return "expired";
  return "active";
};

export const isScheduleActive = (startDate, endDate) => scheduleStatus(startDate, endDate) === "active";

export const formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return "Ongoing";
  const format = (value) =>
    new Date(`${value}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  if (startDate && endDate) return `${format(startDate)} – ${format(endDate)}`;
  return startDate ? `From ${format(startDate)}` : `Until ${format(endDate)}`;
};

export const buildBookingUrl = (bookingUrl, promoCode = "") => {
  if (!bookingUrl) return "";
  const base = extUrl(bookingUrl);
  const code = promoCode.trim();
  if (!code) return base;
  // Exely/HopenAPI booking pages read promoCodePlain, and query params must come before the #/search hash
  if (base.includes("hopenapi.com")) {
    const [beforeHash, hash] = base.split("#");
    const [path, query] = beforeHash.split("?");
    const params = new URLSearchParams(query || "");
    params.delete("promoCodePlain"); // never duplicate, even if the base URL already carries one
    params.set("promoCodePlain", code);
    return `${path}?${params.toString()}${hash ? `#${hash}` : ""}`;
  }
  const separator = base.includes("?") ? "&" : "?";
  return `${base}${separator}promo=${encodeURIComponent(code)}`;
};

export const parseLines = (value) => String(value || "").split("\n").map((line) => line.trim()).filter(Boolean);

// Config keys owned by the /book page itself; everything else (room-type, promoCodePlain,
// date, nights, adults, ...) is a deep-link param carried through to the embedded engine.
const BOOKING_CONFIG_KEYS = ["accommodationMode", "currency", "language", "providerId", "theme", "int", "origin", "path", "width", "fullScreenOnMobile"];

// Same-tab booking: navigate to our /book page where the official Exely engine is embedded
// inline via the vendor integration script (no popup, no test-mode toolbar, no off-domain
// redirect). Deep-link params ride along in the /book URL and are inherited by the engine.
export const goBooking = (target) => {
  if (!target) return;
  const url = extUrl(target);
  if (url.includes("hopenapi.com")) {
    const query = url.split("#")[0].split("?")[1] || "";
    const params = new URLSearchParams(query);
    BOOKING_CONFIG_KEYS.forEach((key) => params.delete(key));
    const qs = params.toString();
    window.location.href = `/book${qs ? `?${qs}` : ""}`;
    return;
  }
  window.location.href = url;
};
